const columns = [
  {
    title: "نام سرویس",
    dataIndex: "serviceName",
    key: "serviceName",
    width: 170,
    ellipsis: true,
  },
  {
    title: "نوع سرویس",
    dataIndex: "serviceType",
    key: "serviceType",
    width: 130,
  },
  {
    title: "وضعیت",
    dataIndex: "status",
    key: "status",
    width: 130,
  },
  {
    title: "تاریخ شروع",
    dataIndex: "startAt",
    key: "startAt",
    width: 140,
    sorter: true,
  },
  {
    title: "تاریخ پایان",
    dataIndex: "endAt",
    key: "endAt",
    width: 140,
    sorter: true,
  },
  {
    title: "مبلغ (ریال)",
    dataIndex: "amount",
    key: "amount",
    width: 130,
    sorter: true,
  },
  {
    title: "تاریخ خرید",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 130,
    sorter: true,
  },
  {
    title: "عملیات",
    dataIndex: "actions",
    key: "actions",
    width: 150,
  },
];

export default columns;
